// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"fe9bee2b","787":"aadca95f","954":"997ee716"}[chunkId] + ".chunk.js";
};